import { Star } from 'lucide-react';
import { DrinkVariant } from '@/config/drinkVariants';

interface ReviewsSectionProps {
  currentVariant: DrinkVariant;
}

const ReviewsSection = ({ currentVariant }: ReviewsSectionProps) => {
  return (
    <section id="reviews" className="py-24 md:py-32 bg-background relative">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-medium tracking-[0.3em] text-primary uppercase mb-4 block">
            Testimonials
          </span>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-foreground mb-4">
            What People <span className="text-primary">Say</span>
          </h2>
          <div className="flex items-center justify-center gap-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star key={star} className="w-6 h-6 text-primary fill-primary" />
            ))}
            <span className="ml-2 text-lg font-medium text-foreground">4.9</span>
            <span className="text-muted-foreground">/ 5.0</span>
          </div>
        </div>

        {/* Reviews grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {currentVariant.reviews.map((review, index) => (
            <div
              key={index}
              className="p-6 bg-card rounded-2xl border border-border hover:border-primary/30 transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-primary fill-primary" />
                ))}
                {Array.from({ length: 5 - review.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-muted-foreground/30" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-foreground mb-4 leading-relaxed">"{review.text}"</p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="font-display text-lg text-primary">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-medium text-foreground">{review.name}</p>
                  <p className="text-xs text-muted-foreground">{review.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
